import {PillTag} from 'components/system/pilltag';
import {PillTagGroup} from 'components/system/pilltag_group';
import {useMemo} from 'react';

export const TopQuestionTags = ({
  questions,
  config,
  maxVisible,
  onConfigChange,
  questionFilter,
}: Props) => {
  const tags = useMemo(() => {
    const counter: Record<string, {count: number; isPrimary: boolean}> = {};
    for (const question of questions) {
      for (const tag of question.tags) {
        if (!counter[tag.name]) {
          counter[tag.name] = {count: 0, isPrimary: tag.is_primary};
        }
        counter[tag.name].count += 1;
      }
    }

    return Object.entries(counter)
      .sort(([_1, info_1], [_2, info_2]) => info_1.count - info_2.count)
      .sort(([_1, info_1], [_2, info_2]) => (info_1.isPrimary ? -1 : info_2.isPrimary ? 1 : 0))
      .sort(([tagName_1, _1], [tagName_2, _2]) =>
        config.tags.includes(tagName_1) && !config.tags.includes(tagName_2) ? -1 : 1,
      )

      .filter(([tag, _]) => {
        return (
          !questionFilter ||
          questionFilter === '' ||
          tag.toLowerCase().includes(questionFilter.toLowerCase())
        );
      })
      .slice(0, maxVisible)
      .map(([tag, _]) => tag);
  }, [questions, maxVisible, questionFilter, config]);

  const pillTags = useMemo(() => {
    return tags.map((tag) => {
      const selected = config.tags.includes(tag);

      const addQuestionTag = () => {
        onConfigChange({
          ...config,
          tags: [...config.tags, tag],
          page: 0,
        });
      };

      const removeQuestionTags = () => {
        onConfigChange({
          ...config,
          tags: config.tags.filter((c) => c !== tag),
          page: 0,
        });
      };

      const handleClick = () => {
        if (selected) removeQuestionTags();
        else addQuestionTag();
      };

      return (
        <PillTag key={tag} color={selected ? 'blue' : 'greyLight'} onClick={handleClick}>
          {tag}
        </PillTag>
      );
    });
  }, [tags, config, onConfigChange]);

  return tags.length > 0 ? <PillTagGroup>{pillTags}</PillTagGroup> : <div>No tags found</div>;
};

type Props = {
  questions: Question[];
  config: QuestionListConfig;
  maxVisible: number;
  questionFilter?: string;
  onConfigChange: (config: QuestionListConfig) => void;
};
